import classnames from 'classnames';
import React from 'react';

import { ITabPaneProps } from './types';

const TabPane: React.FC<ITabPaneProps> = ({ children }) => {
  const tabPaneClassName = classnames('custom-tabs-tab-content');
  return <div className={tabPaneClassName}>{children || null}</div>;
};

export default React.memo(TabPane);
